import { h } from 'preact';
import { Text } from 'preact-i18n';
import StockSymbolTable from '../stock-symbol-table';
import style from './style';

const SectorsPanel = () => (
	<div class={style['sectors-panel']}>
		<div class={style['panel-header']}><Text id="SECTORS" /></div>
		<div>
			<div class={style['widget-panel']}>
				<StockSymbolTable
					showHeaders={['Sector', 'Price', 'Change %', '1 Month %', '3 Month %', '52 Week %']}
					symbols={['MSECTOR1', 'MSECTOR2', 'MSECTOR3', 'MSECTOR4', 'MSECTOR5', 'MSECTOR6', 'MSECTOR7', 'MSECTOR8', 'MSECTOR9']}
					columns={['name', 'price', 'changePercent', 'oneMonthChangePercent', 'threeMonthChangePercent', '52WeekChangePercent']}
				/>
			</div>
		</div>
	</div>
);
export default SectorsPanel;
